<script lang="ts" setup>
import { ref } from 'vue';
import './Login.scss';
import { useRouter } from 'vue-router';
import { inputsLogin } from '@services/forms/inputsLogin';
import autenticacionRepository from '@repositories/autenticacion.repository';
import { useI18n } from 'vue-i18n';
import CaptchaCloudflare from './CaptchaCloudflare.vue';

const { t } = useI18n();
const router = useRouter();
const autenticacionController = new autenticacionRepository();

const refForm = ref<any>(null);
const errorMessage = ref<string | null>(null);
const loading = ref<boolean>(false);
const codeSent = ref<boolean>(false);
const email = ref<string>('');
const tokenCaptcha = ref<string | null>(null);
const captchaRef = ref<any>(null);

const handleTokenCaptcha = (token: string) => {
  tokenCaptcha.value = token;
};

const handleOnExpired = () => {
  tokenCaptcha.value = null;
};

const sendMail = async () => {
  const { items, isFormValid } = await refForm.value.getValues();
  if (!isFormValid) return;

  if (!tokenCaptcha.value) {
    errorMessage.value = t('autenticacion.login.por_favor_verifica_el_captcha');
    return;
  }

  errorMessage.value = null;

  try {
    const response = await autenticacionController.sendCodeRecovery({
      ...items,
      captchaToken: tokenCaptcha.value,
    });

    if (response.msg === 'ok') {
      codeSent.value = true;
      email.value = items.email;
    }
  } catch (error: any) {
    if (error?.message === "You're not user") {
      errorMessage.value = 'Usuario no encontrado o no registrado';
    } else {
      errorMessage.value = 'Ocurrió un error inesperado';
    }
  } finally {
    captchaRef.value?.reset();
  }
};
</script>

<template>
  <div class="login-container">
    <div class="login-container__card">
      <div class="login-container__header">
        <div class="login-container__logo-wrap">
          <img
            src="/img/tryger-logo.png"
            alt="Tryger"
            class="login-container__logo"
          />
        </div>
      </div>
      <div class="login-container__content">
        <div class="login-container__firstBox">
          <div class="text-center login-container__title">
            {{ t('autenticacion.send_mail_recovery.enviar_codigo_por_correo') }}
          </div>
        </div>
        <div
          class="d-flex flex-column justify-content-center align-items-center login-container__form w-100"
        >
          <template v-if="errorMessage">
            <div class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </template>
          <div v-if="loading">
            <Overlay
              :show="loading"
              :circleColor="'#40a4c6'"
              :borderColor="'#40a4c6'"
            />
          </div>
          <template v-else-if="!codeSent">
            <div class="d-flex justify-content-center">
              <Form
                :inputs="[inputsLogin()[0]]"
                @focus="errorMessage = null"
                @change="errorMessage = null"
                ref="refForm"
              />
            </div>
            <div class="login-container__captcha">
              <CaptchaCloudflare
                ref="captchaRef"
                @verified="handleTokenCaptcha"
                @expired="handleOnExpired"
              />
            </div>
            <CButton
              class="py-2 w-100 my-3"
              :text="t('autenticacion.send_mail_recovery.enviar_email')"
              :background="`background-blue`"
              :disabled="loading"
              @click="sendMail"
              type="button"
            />
            <div
              class="d-flex justify-content-center login-container__back-link mb-2"
            >
              <router-link to="/login">
                <p class="m-0">
                  {{ t('autenticacion.send_mail_recovery.volver_al_login') }}
                </p>
              </router-link>
            </div>
          </template>
          <template v-else>
            <p>
              {{ t('autenticacion.send_mail_recovery.codigo_enviado_a') }}
              <strong>{{ email }}</strong>
            </p>
            <p>
              {{
                t(
                  'autenticacion.send_mail_recovery.revisa_tu_casilla_de_correo',
                )
              }}
            </p>
            <CButton
              class="py-2 w-100 my-3"
              :text="t('autenticacion.send_mail_recovery.volver_al_login')"
              :background="`background-blue`"
              :disabled="loading"
              @click="router.push({ name: 'Login' })"
              type="button"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
